module.exports = __webpack_public_path__ + "static/qrCode-313dff20119cca570c3327d5238259aa.png";